module.exports = __webpack_public_path__ + "img/下载.7f7652b3.svg";